import styled from "styled-components";

export const PageWrapper = styled.div`
  background: var(--ink, #1A1814);
  color: var(--cream, #F3ECE1);
  min-height: 100vh;
  min-height: 100dvh;

  @supports (padding: max(0px)) {
    padding-left: max(0px, env(safe-area-inset-left));
    padding-right: max(0px, env(safe-area-inset-right));
  }
`;

export const Wrap = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding-inline: clamp(20px, 4.5vw, 64px);
`;

/* ---------- hero ---------- */
export const TyHero = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 440px);
  gap: clamp(40px, 6vw, 96px);
  align-items: center;
  padding-block: 72px 80px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    padding-block: 48px 56px;
  }
`;

export const TyEb = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  font: 500 12px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--red, #D9442B);

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--red, #D9442B);
    box-shadow: 0 0 0 5px rgba(217, 68, 43, 0.18);
  }
`;

export const TyHeroH1 = styled.h1`
  margin: 22px 0 0;
  font: 400 clamp(52px, 6.2vw, 88px) / 0.95 'Instrument Serif', Georgia, serif;
  letter-spacing: -0.02em;
  max-width: 11em;

  em {
    color: var(--red, #D9442B);
    font-style: italic;
  }
`;

export const TySub = styled.p`
  margin: 26px 0 0;
  font-size: 20px;
  color: var(--text, #CFC6B8);
  max-width: 30em;
`;

export const TyHeroPicture = styled.picture`
  img {
    display: block;
    width: 100%;
    height: auto;
  }

  @media (max-width: 1024px) {
    max-width: 420px;
  }
`;

/* ---------- steps ---------- */
export const TySteps = styled.div`
  border-top: 1px solid var(--cream, #F3ECE1);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const TyStep = styled.div`
  padding: 28px 32px 40px 0;

  & + & {
    padding-left: 32px;
    border-left: 1px solid var(--line, #3A342C);

    @media (max-width: 760px) {
      padding-left: 0;
      border-left: 0;
      border-top: 1px solid var(--line, #3A342C);
      padding-top: 24px;
    }
  }

  @media (max-width: 760px) {
    padding-bottom: 28px;
  }
`;

export const TyStepN = styled.span`
  font: 400 11px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.16em;
  color: var(--red, #D9442B);
`;

export const TyStepH2 = styled.h2`
  margin: 12px 0 10px;
  font: 400 32px / 1.05 'Instrument Serif', Georgia, serif;
  letter-spacing: -0.01em;
`;

export const TyStepP = styled.p`
  margin: 0;
  font-size: 17px;
  color: var(--text, #CFC6B8);

  b {
    color: var(--cream, #F3ECE1);
    font-weight: 500;
  }
`;

/* ---------- tips ---------- */
export const TyTips = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  padding-block: 16px 96px;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

export const TyTip = styled.div`
  background: var(--ink-2, #221F1A);
  border: 1px solid var(--line, #3A342C);
  border-top: 2px solid var(--red, #D9442B);
  padding: 28px 32px 30px;
`;

export const TyTipLab = styled.span`
  font: 400 11px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--red, #D9442B);
`;

export const TyTipH3 = styled.h3`
  margin: 10px 0 10px;
  font: 400 26px / 1.1 'Instrument Serif', Georgia, serif;
`;

export const TyTipP = styled.p`
  margin: 0;
  font-size: 16.5px;
  color: var(--text, #CFC6B8);

  a {
    color: var(--cream, #F3ECE1);
    text-decoration: none;
    border-bottom: 1px solid var(--red, #D9442B);
  }
`;

/* ---------- footer ---------- */
export const TyFoot = styled.footer`
  border-top: 1px solid var(--line, #3A342C);
`;

export const TyFootWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px 32px;
  padding-block: 28px;
  font: 400 11px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--faint, #6F675C);
`;

/* ---------- loading state ---------- */
export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  gap: 16px;
  color: var(--text, #CFC6B8);
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(216, 208, 195, 0.2);
  border-top-color: #D9442B;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

/* ---------- Legacy components for cancel page ---------- */
export const SuccessContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 80px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(217, 68, 43, 0.15);
  border: 2px solid rgba(217, 68, 43, 0.3);
  margin-bottom: 32px;

  svg {
    color: #D9442B;
  }
`;

export const Title = styled.h1`
  font-family: 'Instrument Serif', Georgia, serif;
  font-size: 3rem;
  font-weight: 400;
  color: #F3ECE1;
  line-height: 1.1;
  margin-bottom: 24px;
`;

export const Message = styled.p`
  font-size: 1.125rem;
  color: #CFC6B8;
  line-height: 1.6;
  margin-bottom: 40px;
`;

export const InfoBox = styled.div`
  background: rgba(217, 68, 43, 0.05);
  border: 1px solid rgba(217, 68, 43, 0.2);
  padding: 32px;
  margin-bottom: 24px;
  width: 100%;
  text-align: left;
`;

export const InfoText = styled.p`
  font-size: 1rem;
  color: #CFC6B8;
  line-height: 1.6;
  margin: 0;

  a {
    color: #F3ECE1;
    text-decoration: none;
    border-bottom: 1px solid rgba(217, 68, 43, 0.3);
    transition: border-color 0.2s;

    &:hover {
      border-color: #D9442B;
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  max-width: 400px;

  @media (max-width: 568px) {
    flex-direction: column;
  }
`;

export const PrimaryButton = styled.button`
  flex: 1;
  padding: 16px 32px;
  background: #D9442B;
  color: #F3ECE1;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;

  &:hover {
    background: #C23A24;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SecondaryButton = styled.button`
  flex: 1;
  padding: 16px 32px;
  background: transparent;
  color: #F3ECE1;
  border: 2px solid rgba(217, 68, 43, 0.3);
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;

  &:hover {
    border-color: #D9442B;
    background: rgba(217, 68, 43, 0.1);
  }

  &:active {
    transform: scale(0.98);
  }
`;
